module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['input-form-wrap-row', 'spacing-height', _vm.inputStyleClass]
  }, [_c('div', {
    staticClass: "input-label"
  }, [(_vm.required) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.label))])]), _vm._v(" "), _c('el-input', {
    staticClass: "input-form",
    style: (_vm.customStyle),
    attrs: {
      "value": _vm.value,
      "size": "mini",
      "readonly": _vm.readonly
    },
    on: {
      "input": _vm.handleInput
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2fdbe6e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/components/orderCreate/InputField.vue
// module id = 683
// module chunks = 0